<template>
  <div>
    <v-dialog v-model="checkoutPaymentVueDialog" max-width="700" scrollable v-if="!isConfirmCheckinBooking">
      <v-card v-if="!isLoading" outlined>
        <v-card-title class="flex justify-between">
          <span>{{
            isCreate
            ? text.isCreate + text.title
            : isUpdate
              ? text.isUpdate + text.title
              : $t('checkout_title')
          }}</span>
          <!-- close button -->
          <v-btn icon color="error" @click="checkoutPaymentVueDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5" v-if="getCheckout">
          <v-alert
            outlined
            :color="getCheckout.statusClass ? getCheckout.statusClass.color : ''"
            text
            class="mb-0 font-weight-regular py-2 text-center px-2 rounded-md"
          >
            <div class="my-2" style="font-size: 14px;">{{ $t('area.checkout_status') }}</div>
            <div class="my-2" style="font-size: 24px;">
              {{
                getCheckout.statusClass
                ? getCheckout.statusClass.text
                : $t('invalid_data')
              }}
            </div>
            <div class="my-2 black--text" style="font-size: 14px;">({{ $t('contract.checkout_type') }} : 
              <span class="font-bold" v-if="getCheckout.isEscaped">{{ $t('contract.escaped') }}</span>
              <span class="font-bold" v-else-if="getCheckout.isCloseContract">{{ $t('contract.close_contract') }}</span>
              <span class="font-bold" v-else>{{ $t('contract.reduce_area') }}</span>)
            </div>
            <div class="my-2 text-center" v-if="getCheckout.status == 'success'">
              {{ $t('area.checkout_date_when') }} {{ getCheckout.statusUpdatedAtString || "-" }}
            </div>
          </v-alert>
          
          <template v-if="getCheckout.isEscaped">
            <AlertCard class="mt-3 rounded-lg" color="info">
              <template v-slot:title>
                <div>{{ $t('area.summary_checkout') }}</div>
              </template>
              <template v-slot:content>
                <div class="pt-7 pb-4 px-5">
                  <div class="d-flex gap-3">
                    <BoxCheckoutSummary 
                      color="error" 
                      :totalValue="getCheckout.unpaidTotalCost + getCheckout.checkOutTotalCost" 
                      :title="$t('bill.bad_debt')"
                    />
                    <BoxCheckoutSummary 
                      color="success" 
                      :totalValue="getCheckout.depositTotalCost" 
                      :title="$t('contract.deposit_received')"
                    />
                  </div>
                </div>
              </template>
            </AlertCard>
          </template>
          <div v-else>
            <template v-if="getCheckout.totalCost != 0">
              <BoxCheckoutSummary
                class="mt-3"
                :color="getCheckout.isPaidClass ? getCheckout.isPaidClass.color : ''" 
                :totalValue="getCheckout.totalCostAbs" 
                :title="getCheckout.isPaidClass && getCheckout.isPaidClass.text ? getCheckout.isPaidClass.text : ''"
                :isNoShadow="true"
              >
                <template v-slot:content v-if="getCheckout.isPaid">
                  <hr class="mt-3 mb-2" style="color: white !important; position: relative;">
                  <div class="text-center black--text" style="font-size: 14px;">
                    <div class="mb-2">
                      {{ $t('area.channel') }}{{ getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.pay') }} : 
                      {{ getCheckout.paymentMethodString }}
                    </div>
                    <div class="payment-proof-file"
                      v-if="getCheckout.paymentProofFiles && getCheckout.paymentProofFiles.length > 0">
                      <v-expansion-panels>
                        <v-expansion-panel v-model="isShowPaymentProofFiles">
                          <v-expansion-panel-header>
                            {{ `${$t('customer.proof_of')}${getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.pay')}` }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-btn v-for="(file, key) in getCheckout.paymentProofFiles" :key="`image-proof-${key}`" link
                              target="_blank" :href="file.url">
                              <img :src="file.url" />
                            </v-btn>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                    <div class="mb-2">
                      {{ getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.receive_payment') }}{{ $t('by') }} : {{ getCheckout.getReceivedBy }}
                    </div>
                    <div class="mb-2" v-if="getCheckout.paymentNote">
                      {{ $t('note') }}
                      {{
                        getCheckout.totalCost > 0 ? $t('payment.refund_payment') : $t('payment.payment_acceptance')
                      }} :
                      {{ getCheckout.paymentNote }}
                    </div>
                    <div>
                      {{ getCheckout.totalCost > 0 ? $t('payment.return') : $t('payment.pay_only') }}{{ $t('when') }} :
                      {{ $moment(getCheckout.payDate).format(`dddd ${$t('at')} DD MMMM YYYY`) }}
                    </div>
                  </div>
                </template>
              </BoxCheckoutSummary>
            </template>
          </div>

          <!-- <div v-if="getCheckout.totalCost != 0" :class="`p-5 mb-5 rounded-xl ${getCheckout.isPaidClass ? getCheckout.isPaidClass.css : ''
            } border-2`">
            <div :class="`flex items-center ${getCheckout.isPaid
              ? 'justify-between'
              : 'justify-center flex-col items-center'
              }`">
              <div :class="!getCheckout.isPaid ? 'text-sm text-center' : 'text-lg payment-box'">
                <span class="block">{{
                  getCheckout.isPaidClass
                  ? getCheckout.isPaidClass
                    ? getCheckout.isPaidClass.text
                    : ""
                  : ""
                }}</span>

                <template v-if="getCheckout.isPaid">
                  <div class="text-base">
                    {{ $t('area.channel') }}{{
                      getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.pay')
                    }}
                    : {{ getCheckout.paymentMethodString }}

                  </div>
                  <div class="payment-proof-file"
                    v-if="getCheckout.paymentProofFiles && getCheckout.paymentProofFiles.length > 0">
                    <v-expansion-panels>
                      <v-expansion-panel v-model="isShowPaymentProofFiles">
                        <v-expansion-panel-header>
                          {{ `${$t('customer.proof_of')}${getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.pay')}` }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-btn v-for="(file, key) in getCheckout.paymentProofFiles" :key="`image-proof-${key}`" link
                            target="_blank" :href="file.url">
                            <img :src="file.url" />
                          </v-btn>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                  <div class="text-base">
                    {{
                      getCheckout.totalCost > 0 ? $t('payment.refund') : $t('payment.receive_payment')
                    }}{{ $t('by') }} : {{ getCheckout.getReceivedBy }}
                  </div>
                  <div class="text-base" v-if="getCheckout.paymentNote">
                    {{ $t('note') }}
                    {{
                      getCheckout.totalCost > 0 ? $t('payment.refund_payment') : $t('payment.payment_acceptance')
                    }} :
                    {{ getCheckout.paymentNote }}
                  </div>
                  <div class="text-base">
                    {{ getCheckout.totalCost > 0 ? $t('payment.return') : $t('payment.pay_only') }}{{ $t('when') }} :
                    {{ $moment(getCheckout.payDate).format(`dddd ${$t('at')} DD MMMM YYYY`) }}
                  </div>
                </template>
              </div>
              <div class="text-right payment-box-right" v-if="getCheckout.isPaid">
                <span>{{ $t('bill.amount') }}</span>
                <div class="text-xl">
                  {{ getCheckout.totalCostAbs | currencySuffixSign(getCheckout.currencyCode) }}
                </div>
              </div>
              <div class="text-center" v-else>
                <div class="text-2xl">
                  {{ getCheckout.totalCostAbs | currencySuffixSign(getCheckout.currencyCode) }}
                </div>
              </div>
            </div>
          </div> -->

          <v-card v-if="getCheckout.invoicePayment" class="mt-3">
            <v-card-text>
              <h2 class="py-0">{{ $t('payment.notify_payment') }}</h2>
            </v-card-text>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="">
                  <a v-for="(img, index) in getCheckout.invoicePayment.paymentProofFiles"
                    class="w-100 flex items-center justify-center mb-3" :key="index" :href="img.url" target="_blank">
                    <v-img max-width="250" :src="img.url" />
                  </a>
                </v-col>
                <v-col cols="6" v-if="getCheckout.invoicePayment.paymentBankAccount" style="font-size: 18px">
                  <h3 class="mb-5"><b>{{ $t('payment.transfer_to_account') }}</b></h3>
                  <p><b>{{ $t('payment.bank') }} : </b>
                    <img style="display: inline;border-radius: 50%;" width="40"
                      :src="require(`../assets/images/bank/${getCheckout.invoicePayment.paymentBankAccount.bankCode}.jpg`)" />
                    {{ BankData[getCheckout.invoicePayment.paymentBankAccount.bankCode].name }}
                  </p>
                  <p><b>{{ $t('payment.account_number') }} : </b> {{ getCheckout.invoicePayment.paymentBankAccount.accountName }}</p>
                  <p><b>{{ $t('payment.account_name') }} : </b> {{ getCheckout.invoicePayment.paymentBankAccount.accountNumber }}</p>

                  <br />

                  <p><b>{{ $t('payment.attached_when') }} : </b> {{ $moment(getCheckout.invoicePayment.createdAt).format("lll") }}</p>
                  <p><b>{{ $t('payment.attached_by') }} : </b> {{ getCheckout.invoicePayment.customerUser.user.firstName }} {{
                    getCheckout.invoicePayment.customerUser.user.lastName }}</p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="isCacelPaymentProofDialog = true" color="error">
                {{ $t('payment.cancel_notify_payment') }}
              </v-btn>
            </v-card-actions>
          </v-card>
          <div class="mt-3" v-if="!isHideActions">
            <v-btn block rounded color="orange" dark large elevation="0"
              v-if="getCheckout.totalCost < 0 && !getCheckout.isPaid" @click="onExtra">{{ $t('payment.pay') }}</v-btn>
            <v-btn block rounded color="info" large elevation="0" @click="onRefund"
              v-if="getCheckout.totalCost > 0 && !getCheckout.isPaid">
              <v-icon left>mdi-cash-refund</v-icon>
              {{ $t('payment.refund') }}
            </v-btn>
          </div>
          <div class="mt-3">
            <v-label for="checkout-date">{{ $t('area.checkout_date') }}</v-label>
            <v-text-field hide-details outlined id="checkout-date" rounded disabled
              v-model="getCheckout.checkOutDateFormet"></v-text-field>
          </div>
          <div class="mt-3">
            <v-label for="checkout-note">{{ $t('note') }}</v-label>
            <v-text-field hide-details outlined id="checkout-note" rounded disabled
              v-model="getCheckout.note"></v-text-field>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="flex-wrap gap-2 pb-3">
          <div class="flex gap-2">
            <v-btn style="flex: 1;" large color="info darken-2" elevation="0" rounded @click="isPrintDialog = true">
              <v-icon left>mdi-printer</v-icon>
              {{ $t('area.print_checkout_sheet') }}
            </v-btn>
            <v-btn v-if="!isHideActions" style="flex: 1;" large class="info darken-1" elevation="0" @click="isCheckoutDialog = true" rounded>
              <v-icon left>mdi-magnify</v-icon>
              {{ $t('view_detail') }}
            </v-btn>
          </div>
          <v-btn v-if="!isHideActions" large block rounded color="primary" elevation="0" @click="isConfirmCheckoutDialog = true"
            :loading="isSuccessLoading" :disabled="getCheckout.status == 'success' || isSuccessLoading">
            <v-icon left>mdi-check</v-icon>
            {{ $t('validate.confirm_checkout') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else class="flex justify-center align-center" outlined height="700">
        <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" right color="error">{{ $t('error') }}</v-snackbar>
    <PaymentFormDialog
      v-model="isCPayment"
      :isHideSplitPay="true"
      :dialogType="payType"
      :contractCheckout="getCheckout"
      :paymentMethod="tempInvoicePayment ? tempInvoicePayment.paymentMethod : null"
      :paymentProofFiles="tempInvoicePayment ? tempInvoicePayment.paymentProofFiles : null"
      :paymentBankAccount="tempInvoicePayment ? tempInvoicePayment.paymentBankAccount : null"
      @onSaveSuccess="saveSuccess"
    />
    <CheckoutDialog v-if="isCheckoutDialog" :contractCheckOutId="getCheckout.objectId" v-model="isCheckoutDialog" />
    <CheckoutPrint :checkoutId="getCheckout.objectId" v-model="isPrintDialog" />
    <ConfirmDialogComponent v-model="isConfirmCheckoutDialog" :text="$t('validate.when_confirm_checkout_data_cannot_be_edited')"
      @onOk="successCheckout" :title="$t('validate.confirm_checkout')" :textBtnOk="$t('confirm')" />
    <ConfirmDialogComponent v-model="isCacelPaymentProofDialog" :title="$t('validate.confirm_cancel_payment')"
      :textBtnOk="$t('confirm')" :textBtnCancel="$t('close')" type="error" @onOk="onCancelInvoicePayment" />
    <ConfirmDialogComponent v-model="isConfirmCheckinBooking" :text="$t('validate.confirm_checkout')"
      :title="$t('validate.confirm_checkout')" :textBtnOk="$t('confirm')" />
    <v-dialog v-model="isConfirmCheckinBooking" persistent max-width="600px">
      <v-card>
        <v-card-title class="blue text-white">
          <h4>{{ $t('validate.have_contract_waiting_for_checkin_you_want_to_checkin') }}</h4>
        </v-card-title>
        <v-card-text >
          <template v-if="hashBooking">
            <v-card v-for="booking in hashBooking" :key="booking.objectId" class="mt-4">
              <v-card-text class="pt-2">
                <div><b>{{ $t('contract.contract_number_only') }} : </b> {{ booking.contract.contractId || "-" }}</div>
                <div><b>{{ $t('contract.business_name') }} : </b> {{ booking.contract.businessName || "-" }}</div>
                <div><b>{{ $t('customer.company_name_and_customer_name') }} : </b> {{ booking.contract.billingData.name || "-" }}</div>
                <v-card v-for="areaBooking in booking.areaBookings" :key="areaBooking.objectId" class="mt-4">
                  <v-card-text class="pt-2 flex justify-space-between align-center">
                    <div>
                      <div>{{ $t('market.market_title') }} :  {{ areaBooking.area.name || "-" }}</div>
                      <div>{{ $t('contract.start_date') }} : {{ $moment(areaBooking.startDate.iso).format("D/MM/YYYY") }}</div>
                      <div>{{ $t('contract.end_date') }} : {{ $moment(areaBooking.endDate.iso).format("D/MM/YYYY") }}</div>
                    </div>
                    <div>
                      <v-btn
                        v-if="!areaBooking.isSuccess"
                        :disabled="areaBooking.isSuccess"
                        color="success" 
                        @click="checkInArea(areaBooking)"
                        :loading="isSuccessLoading"
                      >
                        {{ $t('area.enter_stall') }}
                      </v-btn>
                      <span class="green--text" v-if="areaBooking.isSuccess">{{ $t('area.already_enter_stall') }}</span>
                    </div>
                  </v-card-text>
                  
                </v-card>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            elevation="0"
            @click="closeBooking()"
            :disabled="isSuccessLoading"
          >{{ $t('close') }}</v-btn>
          <v-btn
            color="success"
            type="submit"
            elevation="0"
            :disabled="isSuccessLoading || isDisableCheckInAll"
            @click="checkInAreaAll()"
          >{{ $t('area.enter_all_stall') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CPayment from "./CPayment.vue";
import CheckoutDialog from "./CheckoutDialog.vue";
import CheckoutPrint from "./CheckoutPrint.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import PaymentFormDialog from "./paymentFormDialog.component";
import AlertCard from "./AlertCard.component.vue";
import BoxCheckoutSummary from "./BoxCheckoutSummary.component.vue";
import BankData from "../json/bank-data.json";
import { ContractCheckout, AreaBooking } from "../classes";
export default {
  components: {
    CPayment,
    CheckoutDialog,
    CheckoutPrint,
    ConfirmDialogComponent,
    PaymentFormDialog,
    AlertCard,
    BoxCheckoutSummary
  },
  name: "CheckoutPaymentVue",
  computed: {
    ...mapGetters({
      getCheckout: "contractCheckout/contractCheckout",
      getContractId: "contract/getContractId",
    }),
    checkoutPaymentVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    hashBooking: {
      handler(data) {
        console.log(data)
        this.isDisableCheckInAll = Object.values(data).every(booking => 
          booking.areaBookings.every(area => area.isSuccess)
        )
      },
      deep: true
    },
    value(data) {
      if (data) {
        this.initData();
      }
    },
  },
  created() {
    this.text = {
      title: this.$t('checkout_title'),
      isCreate: "",
      isUpdate: "",
    };
  },
  data() {
    return {
      form: {},
      text: {},
      isCPayment: false,
      isError: false,
      payType: "refund",
      isSuccessLoading: false,
      isCheckoutDialog: false,
      isPrintDialog: false,
      isConfirmCheckoutDialog: false,
      isLoading: false,
      tempInvoicePayment: null,
      BankData: BankData,
      isCacelPaymentProofDialog: false,
      isConfirmCheckinBooking: false,
      hashBooking: {},
      isShowPaymentProofFiles: false,
      isDisableCheckInAll: false
    };
  },
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    isHideActions: Boolean
  },
  methods: {
    async initData() {
      this.isLoading = true
      try {
        this.hashBooking = {}
        await this.$store.dispatch("contractCheckout/getContractCheckout", {
          id: this.objectId || this.getCheckout.objectId,
        });
        this.$emit("onInit");
        this.isLoading = false
      } catch (e) {
        console.log(e);
        this.isLoading = false
      }
    },
    saveSuccess() {
      this.initData();
      this.$emit("onSuccess");
    },
    onRefund() {
      this.payType = "refund";
      this.isCPayment = true;
    },
    onExtra() {
      this.payType = "extra";
      this.tempInvoicePayment = null;
      if (this.getCheckout && this.getCheckout.invoicePayment) {
        this.tempInvoicePayment = this.getCheckout.invoicePayment
      }
      this.isCPayment = true;
    },
    async successCheckout() {
      try {
        this.isSuccessLoading = true;
        await this.$store.dispatch("contractCheckout/successContractCheckout", {
          id: this.getCheckout.objectId,
        });
        let areas = this.getCheckout.areas || []
        let areaBookings = await AreaBooking.getCheckinAreaBookingByAreas({
          areaIds: areas.map(d => d.objectId)
        })
        if(areaBookings.length){
          let _areaBookings = []
          for(let areaBooking of areaBookings){
            if(areaBooking.area?.isOccupied === false && !_areaBookings.find(d => d.area.objectId == areaBooking.area.objectId)){
              _areaBookings.push(areaBooking)
            }
          }
          for(let areaBooking of _areaBookings){
            let bookingId = areaBooking.booking.objectId
            if(!this.hashBooking[bookingId]){
              this.hashBooking[bookingId] = {
                ...areaBooking.booking,
                areaBookings: []
              }
            }
            this.hashBooking[bookingId].areaBookings.push(areaBooking)
          }
          this.isConfirmCheckinBooking = true
        }else{
          this.$emit("onSuccessCheckout");
          this.$eventBus.$emit('updateAreaPlan')
          this.checkoutPaymentVueDialog = false;
        }
        this.isSuccessLoading = false;
      } catch (e) {
        this.isSuccessLoading = false;
        console.log(e);
      }
    },
    async checkInArea(areaBooking) {
      this.isSuccessLoading = true;
      try {
        if(!areaBooking.isSuccess){
          await this.$store.dispatch("areaBooking/checkInAreaBooking", {
            id: areaBooking.objectId
          });
          areaBooking.isSuccess = true
          this.updateIsDisableCheckInAll(this.hashBooking)
        }
        this.$toast.show({
          content: this.$t('area.enter_stall_success'),
          color: "success"
        });
        this.$eventBus.$emit("updateAreaPlan");
        this.isSuccessLoading = false;
      } catch (error) {
        this.isSuccessLoading = false;
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    async checkInAreaAll(){
      this.isSuccessLoading = true;
      try {
        for(let key in this.hashBooking){
          let booking = this.hashBooking[key]
          for(let areaBooking of booking.areaBookings){
            if (!areaBooking.isSuccess) {
              await this.$store.dispatch("areaBooking/checkInAreaBooking", {
                id: areaBooking.objectId
              });
              areaBooking.isSuccess = true
            }
          }
        }
        this.updateIsDisableCheckInAll(this.hashBooking)
        this.$toast.show({
          content: this.$t('area.enter_stall_success'),
          color: "success"
        });
        this.$eventBus.$emit("updateAreaPlan");
        this.isSuccessLoading = false;
        this.closeBooking()
      } catch (error) {
        this.isSuccessLoading = false;
        this.$toast.show({
          content: this.$helper.ShowToastCatchError(error),
          color: "error"
        });
      }
    },
    updateIsDisableCheckInAll(data) {
      this.isDisableCheckInAll = Object.values(data).every(booking => 
        booking.areaBookings.every(area => area.isSuccess)
      )
    },
    closeBooking(){
      this.isConfirmCheckinBooking = false
      this.$emit("onSuccessCheckout");
      this.$eventBus.$emit("updateAreaPlan");
      this.checkoutPaymentVueDialog = false;
    },
    onCancel() {
      try {
        this.checkoutPaymentVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
    async onCancelInvoicePayment() {
      this.isLoading = true
      try {
        await ContractCheckout.cancelContractCheckOutInvoicePayment(this.getCheckout.objectId)
        await this.initData()
        this.$emit("onCancelPaymentApprove", this.getCheckout);
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-box {
  width: 100%;

}

.payment-box-right {
  min-width: 150px;
}

.payment-proof-file {
  position: relative;
  margin: 10px 0;
  min-width: 450px;

  .v-expansion-panel {
    width: 100%;

  }

  .v-expansion-panel-header {
    width: 100%;
  }

  .v-expansion-panel-content__wrap {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    a {
      position: relative;
      height: fit-content;
      margin: 5px;

      img {
        display: block;
        max-width: 150px;
        max-height: 300px;
        height: auto;
        width: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
}
</style>
